import EventHandler from './_dependencyvendor/event-handler';
import { toHTML } from './util/dom-util';
import { optimizeCaller } from './util/util';
import { confineTab, tabIndexble } from './util/a11y';

const initializeCheck = el => {
  return el.getAttribute('data-function-initialized') !== 'initialized';
};
const setInitialize = el => {
  return el.setAttribute('data-function-initialized', 'initialized');
};

const flatpickrKor = {
  weekdays: {
    shorthand: ['일', '월', '화', '수', '목', '금', '토'],
    longhand: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
  },

  months: {
    shorthand: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
    longhand: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
  },

  ordinal: () => {
    return '일';
  },

  rangeSeparator: ' ~ ',
  amPM: ['오전', '오후'],
};

const datepickerValueBinder = () => {
  if (window.flatpickr && !flatpickr.l10ns.ko) {
    flatpickr.l10ns.ko = flatpickrKor;
    flatpickr.localize(flatpickr.l10ns.ko);
  }
};

// 인풋 포커스 활성화 시 레이블 애니메이션 처리
const formInteraction = () => {
  const forms = document.querySelectorAll('.c-form__input');
  forms.forEach(form => {
    if (initializeCheck(form)) {
      setInitialize(form);
      const input = form.querySelector('input');
      let inputValue = input.value;

      if (inputValue.length > 0) {
        form.classList.add('has-value');
      } else {
        form.classList.remove('has-value');
      }

      input.addEventListener('focusout', event => {
        inputValue = input.value;
        if (inputValue.length > 0) {
          form.classList.add('has-value');
        } else {
          form.classList.remove('has-value');
        }
      });
    }
  });
};

// 셀렉트 폼에서 값 선택 후 레이블 및 값 유지 처리
const selectInteraction = () => {
  const selects = document.querySelectorAll('.c-form__select');
  if (selects.length > 0) {
    selects.forEach(eachSelect => {
      if (initializeCheck(eachSelect)) {
        setInitialize(eachSelect);
        const select = eachSelect.querySelector('select');
        let selectValue = select.value;

        if (selectValue.length > 0) {
          eachSelect.classList.add('has-value');
        } else {
          eachSelect.classList.remove('has-value');
        }

        eachSelect.addEventListener('focusout', event => {
          selectValue = select.value;
          if (selectValue.length > 0) {
            eachSelect.classList.add('has-value');
          } else {
            eachSelect.classList.remove('has-value');
          }
        });
      }
    });
  }
};
// 인풋 그룹 포커스 활설화 시 아웃라인 처리
const inputGroupInteraction = () => {
  const forms = document.querySelectorAll('.c-form__input-group input');
  [].forEach.call(forms, input => {
    if (initializeCheck(input)) {
      setInitialize(input);
      input.addEventListener('focusin', e => {
        if (input.getAttribute('readonly') !== null) {
          return;
        }
        e.target.parentElement.parentElement.classList.add('is-focused');
      });
      input.addEventListener('focusout', e => {
        if (input.getAttribute('readonly') !== null) {
          return;
        }
        e.target.parentElement.parentElement.classList.remove('is-focused');
      });
    }
  });
}; // 검색 인풋 버튼 활성화

const searchBoxAction = () => {
  const searchInputs = document.querySelectorAll('.c-form--search');

  if (searchInputs.length > 0) {
    searchInputs.forEach(search => {
      if (initializeCheck(search)) {
        setInitialize(search);
        const inputTarget = search.querySelector('.c-input');
        const resetBtn = search.querySelector('.c-button--reset');
        const searchBtn = search.querySelector('.c-button-round--sm');

        EventHandler.on(inputTarget, 'keyup', e => {
          if (e.currentTarget.value !== '') {
            if (!resetBtn.classList.contains('is-active')) {
              searchBtn.classList.add('is-focus');
              resetBtn.classList.add('is-active');
              EventHandler.one(resetBtn, 'click', () => {
                inputTarget.value = '';
                searchBtn.classList.remove('is-focus');
                resetBtn.classList.remove('is-active');
                inputTarget.focus();
              });
            }
          } else {
            searchBtn.classList.remove('is-focus');
            resetBtn.classList.remove('is-active');
            EventHandler.off(resetBtn, 'click');
          }
        });
      }
    });
  }
};

/**
 * 스크롤 영역 변경
 */
const scrollChange = () => {
  const changeScrollBoxs = document.querySelectorAll('.c-filter--accordion');
  if (changeScrollBoxs.length) {
    changeScrollBoxs.forEach(box => {
      if (initializeCheck(box)) {
        setInitialize(box);
        const expandBtn = box.querySelector('.c-filter--accordion__button');
        EventHandler.on(expandBtn, 'click', e => {
          e.preventDefault();
          e.target.parentNode.classList.toggle('is-expanded');
          if (e.target.parentNode.classList.contains('is-expanded')) {
            e.target.setAttribute('aria-expanded', 'true');
            expandBtn.innerHTML = '<span class="c-hidden">접기</span>';
          } else {
            e.target.setAttribute('aria-expanded', 'false');
            expandBtn.innerHTML = '<span class="c-hidden">펼치기</span>';
          }
        });
      }
    });
  }
};

// 카운터 작동
const counter = () => {
  const counters = document.querySelectorAll('.c-counter');
  if (counters.length) {
    [].forEach.call(counters, el => {
      const btnPlus = el.querySelector('.plus');
      const btnMinus = el.querySelector('.minus');
      const valueBox = el.querySelector('input');
      const min = parseInt(valueBox.getAttribute('min') || -1);
      const max = parseInt(valueBox.getAttribute('max') || -1);
      const step = parseInt(valueBox.getAttribute('step') || 1);
      let initialValue = parseInt(valueBox.value) || min;

      EventHandler.off(btnPlus, 'click');
      EventHandler.off(btnMinus, 'click');

      const updateValue = () => {
        valueBox.value = initialValue;
      };

      valueBox.change = () => {
        const rValue = parseInt(valueBox.value);
        initialValue = rValue >= max ? max : rValue <= min ? min : rValue;
        updateValue();
      };

      EventHandler.on(btnPlus, 'click', () => {
        if (initialValue + step <= max) {
          initialValue += step;
          updateValue();
        }
      });

      EventHandler.on(btnMinus, 'click', () => {
        if (initialValue - step >= min) {
          initialValue -= step;
          updateValue();
        }
      });

      updateValue();
    });
  }
};

// 비교함 바텀시트
const bsCompareBottomSheet = () => {
  const bsCompareBottomSheet = document.querySelectorAll('.c-bs-compare');
  // 어트리뷰트 업데이트
  const updateAttribute = (el, attrs) => {
    if (el) {
      for (const p in attrs) {
        if (attrs.hasOwnProperty(p)) el.setAttribute(p, attrs[p]);
      }
    }
  };

  // show, hide element
  const dimControl = (isShow, el) => {
    if (isShow) {
      document.body.appendChild(el);
      // eslint-disable-next-line no-unused-vars
      const cache = el.offsetHeight;
      el.style.opacity = 0.7;
    } else {
      el.style.opacity = 0;
      setTimeout(() => document.body.removeChild(el), 680);
    }
  };

  if (bsCompareBottomSheet.length > 0) {
    bsCompareBottomSheet.forEach(bs => {
      return (() => {
        if (bs.getAttribute('data-bs-initilazed') !== 'true') {
          bs.getAttribute('data-bs-initilazed', 'true');

          // 상단 배너가 없는경우 no-banner 클래스 부여하여 스타일 처리
          const hasBanner = bs.querySelector('.top-sticky-banner');
          if (!hasBanner) bs.classList.add('no-banner');
          const preview = bs.querySelector('.c-bs-compare__preview');
          const detail = bs.querySelector('.c-bs-compare__detail');
          const container = bs.querySelector('.c-bs-compare__container');
          const inner = bs.querySelector('.c-bs-compare__inner');
          const openButton = bs.querySelector('.c-bs-compare__openner');
          const openButotonText = openButton.querySelector('.sr-only');
          const footer = document.querySelector('.ly-footer');
          const stateOpenText = openButotonText.textContent.split('|');
          const previewHeight = preview ? preview.scrollHeight : 48;
          let detailHeight = detail.scrollHeight;
          const dimEl = toHTML(`<div class="c-bs-dim"></div>`);
          const confine = confineTab(bs);
          let isAnimationg = false;
          let limitTimer = null;
          if (preview) preview.setAttribute('tabindex', 0);
          detail.setAttribute('tabindex', -1);
          setTimeout(() => {
            tabIndexble(detail, true);
          }, 500);
          // top-sticky-banner
          openButotonText.textContent = stateOpenText[0];
          EventHandler.on(window, 'resize.bs-with', () => {
            const isOpen = openButton.classList.contains('is-active');
            if (!isOpen) return;
            if (limitTimer) {
              clearTimeout(limitTimer);
              limitTimer = null;
            }
            limitTimer = setTimeout(() => {
              let containerHeight = detailHeight;
              containerHeight = Math.min(window.innerHeight - 150, containerHeight);
              container.style.height = `${containerHeight}px`;
              detail.style.height = `${containerHeight}px`;
              inner.style.transform = `translateY(${previewHeight * -1}px)`;
            }, 100);
          });
          EventHandler.on(openButton, 'click', e => {
            e.preventDefault();
            if (isAnimationg) return;
            if (!openButton.classList.contains('is-active')) {
              if (Math.abs(detailHeight - detail.scrollHeight) > 3) {
                // 열 때 한번 더 체크(사이즈가 변경되었으면.,)
                detail.style.height = '';
                detailHeight = detail.scrollHeight;
              }
            }

            if (footer && !openButton.classList.contains('is-active')) {
              footer.classList.add('u-hide');
            }

            isAnimationg = true;
            EventHandler.one(inner, 'transitionend', () => {
              isAnimationg = false;
              if (openButton.classList.contains('is-active')) {
                confine.init();
                const topScroll = window.pageYOffset || document.documentElement.scrollTop;
                const leftScroll = window.pageXOffset || document.documentElement.scrollLeft;
                EventHandler.on(window, 'scroll.bs', e => {
                  window.scrollTo(leftScroll, topScroll);
                });
                EventHandler.trigger(bs, 'opened');
              } else {
                EventHandler.off(window, 'scroll.bs');
                EventHandler.trigger(bs, 'closed');
                footer.classList.remove('u-hide');
              }
            });

            const hasClass = openButton.classList.contains('is-active');
            hasClass ? openButton.classList.remove('is-active') : openButton.classList.add('is-active');
            hasClass ? EventHandler.trigger(bs, 'close') : EventHandler.trigger(bs, 'open');
            // 처음부터 보이고 있던 영역
            updateAttribute(preview, {
              'aria-hidden': !hasClass,
              tabindex: hasClass ? 0 : -1,
            });
            // 열릴 때 보여지게 되는 영역
            updateAttribute(detail, {
              'aria-hidden': hasClass,
              tabindex: hasClass ? -1 : 0,
            });
            tabIndexble(detail, hasClass);
            openButotonText.textContent = hasClass ? stateOpenText[0] : stateOpenText[1];
            // 바로 삭제처리
            if (hasClass) confine.destroy();
            // 컨테이너 사이즈 처리
            let containerHeight = hasClass ? previewHeight : detailHeight;
            containerHeight = Math.min(window.innerHeight - 150, containerHeight);

            container.style.height = `${containerHeight}px`;
            detail.style.height = `${containerHeight}px`;
            inner.style.transform = `translateY(${hasClass ? 0 : previewHeight * -1}px)`;
            // 딤 처리
            dimControl(!hasClass, dimEl);
          });
        }
      })();
    });
  }
};

// 사은품 스크롤 영역
const presentsRow = () => {
  const move = (el, posX) => {
    if (el.scroll) {
      el.scrollBy({
        left: posX,
        behavior: 'smooth',
      });
    } else {
      // for ie
      el.scrollBy = posX;
    }
  };

  const getOutsideItem = (viewPortBox, container, viewport, isPrev = false) => {
    const items = container.querySelectorAll('.c-chk-wrap');
    let outsideItem = null;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const itemRect = item.getBoundingClientRect();
      if (isPrev) {
        if (itemRect.left < viewPortBox.left && Math.abs(itemRect.left - viewPortBox.left) > itemRect.width / 3) {
          outsideItem = {
            isFirst: i === 0,
            targetX: Math.floor(itemRect.left - viewPortBox.left),
          };
        }
      } else {
        if (itemRect.width + itemRect.left - viewPortBox.left > viewPortBox.width) {
          const diff = itemRect.width + itemRect.left - viewPortBox.left - viewPortBox.width;
          outsideItem = {
            targetX: diff + 2,
            isLast: i === items.length - 1,
          };
          break;
        }
      }
    }
    return outsideItem;
  };

  const rows = document.querySelectorAll('.presents-wrap');
  rows.forEach(row => {
    const viewport = row.querySelector('.presents-row');
    if (initializeCheck(row)) {
      setInitialize(row);
      const container = row.querySelector('.c-checktype-row');
      const prevButton = row.querySelector('.presents-wrap__button--prev');
      const nextButton = row.querySelector('.presents-wrap__button--next');
      const viewPortBox = viewport.getBoundingClientRect();
      const items = container.querySelectorAll('.c-chk-wrap');
      prevButton.setAttribute('disabled', true);
      nextButton.setAttribute('disabled', true);
      items.forEach(item => {
        const itemRect = item.getBoundingClientRect();
        if (itemRect.width + itemRect.left - viewPortBox.left > viewPortBox.width) {
          nextButton.removeAttribute('disabled');
        }
      });

      EventHandler.on(prevButton, 'click', e => {
        const nextViewItem = getOutsideItem(viewPortBox, container, viewport, 'prev');
        if (nextViewItem) {
          if (nextViewItem.isFirst) {
            prevButton.setAttribute('disabled', true);
          }
          nextButton.removeAttribute('disabled');
          move(viewport, nextViewItem.targetX);
        }
      });

      EventHandler.on(nextButton, 'click', e => {
        const nextViewItem = getOutsideItem(viewPortBox, container, viewport);

        if (nextViewItem) {
          if (nextViewItem.isLast) {
            nextButton.setAttribute('disabled', true);
          }
          prevButton.removeAttribute('disabled');
          move(viewport, nextViewItem.targetX);
        }
      });
    }
  });
};

const headerFixed = () => {
  if (document.querySelector('.main')) return;
  const headerFixedButton = document.querySelector('.ly-header__fixed');
  const lyHeader = document.querySelector('.ly-header');
  const lyContent = document.querySelector('.ly-content');
  const isLoginPage = document.querySelector('.fixed-login');
  if (isLoginPage) {
    lyContent.classList.add('login');
  }
  const tabContent = document.querySelector('.c-tabs--type1');
  // fixed 기능 방지..
  // header 가 없는 경우에도 처리 방지
  if ((tabContent && tabContent.classList.contains('no-fixed')) || !lyHeader) {
    return;
  }
  const defaultFixedStart = isLoginPage ? 155 : 85;
  let tabContentY = -1;
  if (tabContent) {
    tabContentY = tabContent.getBoundingClientRect().top + window.pageYOffset;
  }
  if (headerFixedButton) {
    EventHandler.on(headerFixedButton, 'click', event => {
      event.preventDefault();
      EventHandler.trigger(window, 'openAllMenu');
    });
  }
  if (lyContent) {
    window.addEventListener(
      'scroll',
      optimizeCaller(() => {
        const scTop = window.pageYOffset;
        tabFixed(scTop);
        if (scTop > defaultFixedStart) {
          lyHeader.classList.add('fixed');
          lyContent.classList.add('fixed');
          lyContent.classList.add('fill');
          if (headerFixedButton) headerFixedButton.classList.add('is-active');
        } else {
          lyHeader.classList.remove('fixed');
          lyContent.classList.remove('fixed');
          lyContent.classList.remove('fill');
          if (headerFixedButton) headerFixedButton.classList.remove('is-active');
        }
      }),
    );
  }

  // eslint-disable-next-line no-unused-vars
  const tabFixed = scTop => {
    if (tabContent) {
      if (scTop > tabContentY) {
        lyContent.classList.add('fixed-tab');
      } else {
        lyContent.classList.remove('fixed-tab');
      }
    }
  };
};

const gnb = () => {
  const root = document.querySelector('.ly-header');
  if (!root) return;
  const allMenu = document.querySelector('.ly-allmenu');
  const searchButton = root.querySelector('.ly-header__search-btn');
  const search = document.querySelector('.ly-search');
  const searchClose = search.querySelector('.search__bottom .c-button');
  if (!allMenu) return;
  const allmenuButton = root.querySelector('.ly-header__allmenu');
  const allMenuClose = allMenu.querySelector('.ly-allmenu__close');
  const menuItem = root.querySelectorAll('.nav.nav--depth1 > .nav__item');
  const menuChildren = root.querySelectorAll('.nav.nav--depth2');
  const banner = root.querySelector('.ly-header__banner');
  const bg = root.querySelector('.ly-header__bg');
  const confineTabAllmenu = confineTab(allMenu);
  const confineTabSearch = confineTab(search);

  let bannerSwiper = null;
  let outTime = null;
  let currentMenuHeight = 0;
  let isMouseOver = false;

  const updateBanner = () => {
    if (banner) {
      if (bannerSwiper === null) {
        bannerSwiper = KTM.swiperA11y('.ly-header__banner .swiper-container', {
          navigation: {
            nextEl: '.ly-header__banner .swiper-button-next',
            prevEl: '.ly-header__banner .swiper-button-prev',
          },
          spaceBetween: 30,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
        });
      } else {
        bannerSwiper.update();
      }
    }
  };

  const initTimer = (isStart = false) => {
    if (outTime) {
      clearTimeout(outTime);
      outTime = null;
    }
    if (isStart) {
      outTime = setTimeout(() => {
        showBg(false);
        menuItem.forEach(el => {
          const a = el.querySelector('a');
          a.classList.remove('is-over');
        });
      }, 100);
    }
  };

  // 하위메뉴 전체 hide
  const swapChildMenu = activeMenu => {
    menuChildren.forEach(el => {
      if (el.classList.contains('show-menu')) {
        el.classList.remove('show-menu');
      }
    });
    if (activeMenu) {
      activeMenu.classList.add('show-menu');
      const rect = activeMenu.getBoundingClientRect();
      currentMenuHeight = rect.height < 245 ? 245 + 95 : rect.height + 120;
      bg.style.height = `${currentMenuHeight}px`;
    }
  };

  const getAllMenuMaxHeight = () => {
    const menus = allMenu.querySelectorAll('.nav--depth2');
    let maxHeight = 0;
    menus.forEach(menu => {
      if (maxHeight < menu.offsetHeight) {
        maxHeight = menu.offsetHeight;
      }
    });
    return maxHeight + 160;
  };

  const showSearch = (isOpen = true) => {
    if (isOpen) {
      if (!search.classList.contains('is-active')) {
        search.classList.add('is-active');
        const a = confineTabSearch.init();
        if (a[0]) a[0].focus();
      }
    } else {
      if (search.classList.contains('is-active')) {
        search.classList.remove('is-active');
        confineTabSearch.destroy();
      }
    }
  };

  const showAllMenu = (isOpen = true) => {
    if (isOpen === true) {
      allMenu.style.display = 'block';
      showSearch(false);
      const maxHeight = getAllMenuMaxHeight();
      allMenu.style.height = `${maxHeight}px`;
      // eslint-disable-next-line no-unused-vars
      const cache = allMenu.offsetHeight;
      allMenu.classList.add('is-active');
      document.body.style.overflowY = 'hidden';
      setTimeout(() => {
        const a = confineTabAllmenu.init();
        if (a[0]) a[0].focus();
      }, 400);

      EventHandler.on(window, 'resize.allmenu', () => {
        const windowHeight = window.innerHeight;
        const allmenuHeight = allMenu.offsetHeight;
        if (allmenuHeight > windowHeight) {
          Object.assign(allMenu.style, {
            overflow: 'auto',
            height: `${windowHeight}px`,
          });
        } else {
          Object.assign(allMenu.style, {
            overflow: 'hidden',
            height: `${getAllMenuMaxHeight()}px`,
          });
        }
      });
    } else {
      allMenu.classList.remove('is-active');
      allMenu.style.display = 'none';
      confineTabAllmenu.destroy();
      allMenu.style.height = ``;
      EventHandler.off(window, 'resize.allmenu');
      document.body.style.overflowY = 'auto';
    }
  };

  // navigation bg show
  const showBg = isShow => {
    if (isShow) {
      if (!root.classList.contains('show-menu')) {
        showSearch(false);
        root.classList.add('show-menu');
        banner.style.display = 'block';
        if (bannerSwiper) {
          if (banner.querySelector('.swiper-button-pause')) {
            bannerSwiper.autoplay.start();
          }
        }
        updateBanner();
      }
    } else {
      if (root.classList.contains('show-menu')) {
        root.classList.remove('show-menu');
        banner.style.display = 'none';
        if (bannerSwiper) {
          bannerSwiper.autoplay.stop();
        }
      }
      swapChildMenu();
    }
  };

  EventHandler.on(root, 'mouseover', () => {
    isMouseOver = true;
    initTimer(false);
  });

  EventHandler.on(root, 'mouseout', () => {
    isMouseOver = false;
    initTimer(true);
  });

  // 전체메뉴 열기
  EventHandler.on(allmenuButton, 'click', e => {
    e.preventDefault();
    showAllMenu();
  });

  // 통합검색 열기
  EventHandler.on(searchButton, 'click', e => {
    e.preventDefault();
    const searchEl = document.querySelector('.ly-search');
    if (searchEl.classList.contains('is-active')) {
      showSearch(false);
    } else {
      showSearch();
    }
  });

  // 통합검색 닫기
  EventHandler.on(searchClose, 'click', e => {
    e.preventDefault();
    showSearch(false);
  });

  EventHandler.on(window, 'openAllMenu', () => {
    showAllMenu();
  });

  // 전체메뉴 닫기
  EventHandler.on(allMenuClose, 'click', e => {
    e.preventDefault();
    showAllMenu(false);
  });

  const activeCurrentMenu = el => {
    const currentA = el.querySelector('a');
    menuItem.forEach(el => {
      const a = el.querySelector('a');
      a.classList.remove('is-over');
    });
    swapChildMenu(currentA.nextElementSibling);
    currentA.classList.add('is-over');
    showBg(true);
  };

  menuItem.forEach(el => {
    EventHandler.on(el, 'mouseover', event => {
      activeCurrentMenu(el);
    });
    EventHandler.on(el, 'focusin', event => {
      activeCurrentMenu(el);
    });
  });

  // 접근성 처리

  EventHandler.on(root, 'focusin', e => {
    initTimer(false);
  });

  EventHandler.on(root, 'focusout', e => {
    if (isMouseOver === true) return;
    initTimer(true);
  });
};

const clickToScroll = () => {
  const ellist = document.querySelectorAll('[data-click-to-scroll]');
  ellist.forEach(el => {
    if (initializeCheck(el)) {
      setInitialize(el);
      EventHandler.on(el, 'click.ck-to-scroll', e => {
        const targetSelector = e.currentTarget.getAttribute('data-click-to-scroll');
        const target = document.querySelector(targetSelector);
        if (target) {
          e.preventDefault();
          const targetScrollPos = target.getBoundingClientRect().top + window.pageYOffset;
          EventHandler.on(window, 'scroll.ck-to-scroll', e => {
            if (Math.abs(window.pageYOffset - targetScrollPos) < 1) {
              EventHandler.off(window, 'scroll.ck-to-scroll');
              const focusTarget = target.querySelector('.c-tabs__list .is-active');
              if (focusTarget) focusTarget.focus();
            }
          });
          scrollTo({
            top: targetScrollPos,
            behavior: 'smooth',
          });
        }
      });
    }
  });
};

// Help fab action
const a11yFab = () => {
  const container = document.querySelector('.c-fab');

  let checkTime = null;
  if (container) {
    const openBtn = container.querySelector('.c-fab__open');
    const closeBtn = container.querySelector('.c-fab__close');
    // 웹 접근성 탭 처리
    const gabTabs = confineTab(container);

    EventHandler.on(openBtn, 'click.fab.open', () => {
      openFab();
    });
    EventHandler.on(closeBtn, 'click.fab.close', () => {
      closeFab();
    });

    const openFab = () => {
      container.classList.add('is-opened');
      const t = gabTabs.init();
      if (t[0]) t[0].focus();
      EventHandler.on(window, 'click.fab', e => {
        if (!e.target.closest('.c-fab')) {
          closeFab();
        }
      });
    };

    const closeFab = e => {
      gabTabs.destroy();
      container.classList.remove('is-opened');
      openBtn.focus();
      EventHandler.off(window, 'click.fab');
    };

    window.addEventListener('scroll', e => {
      if (container.classList.contains('is-opened') === true) return;
      if (checkTime) {
        clearTimeout(checkTime);
        checkTime = null;
      }
      if (container.classList.contains('is-active')) {
        container.style.display = '';
        container.classList.remove('is-active');
      }

      checkTime = setTimeout(() => {
        if (!container.classList.contains('is-active')) {
          container.style.display = 'block';
          // eslint-disable-next-line no-unused-vars
          const reflow = container.offsetHeight;
          container.classList.add('is-active');
        }
      }, 300);
    });
  }
};

const selectedCurrentMenu = container => {
  const activeMenu = el => {
    if (!el) return;
    if (el.tagName.toUpperCase() === 'A' || el.tagName.toUpperCase() === 'STRONG') {
      el.classList.add('is-active');
    } else {
      activeMenu(el.children[0]);
    }
  };
  const codeInput = document.querySelector('#gnbMCode');
  if (!codeInput) return;
  const curentPageCode = codeInput.getAttribute('value');
  if (!curentPageCode) return;
  const nav = document.querySelector(container);
  if (!nav) return;
  const selectedAll = nav.querySelectorAll('.is-active');
  selectedAll.forEach(el => {
    if (el.classList) el.classList.remove('is-active');
  });
  const linkCodes = nav.querySelectorAll('[data-code]');
  linkCodes.forEach(a => {
    const codeName = a.getAttribute('data-code');
    if (codeName === curentPageCode) {
      activeMenu(a.closest('.nav.nav--depth1 > .nav__item'));
      activeMenu(a.closest('.nav.nav--depth2 > .nav__item'));
      activeMenu(a);
    }
  });
};

const tabChangeToScroll = () => {
  const elements = document.querySelectorAll('[data-changed-scroll]');
  elements.forEach(el => {
    if (initializeCheck(el)) {
      setInitialize(el);
      EventHandler.on(el, 'ui.tab.change', event => {
        const diffSpacing = 65 + 65;
        const currentContentRect = event.current.content.getBoundingClientRect();
        const resultY = currentContentRect.top + window.pageYOffset - diffSpacing;

        if (diffSpacing < window.pageYOffset) {
          window.scrollTo({
            top: resultY,
          });
        }
      });
    }
  });
};

/**
 * 메인페이지 헤더 고정 시나리오
 * 메인 띠 배너가 없을경우에는 처음부터 fixed를 유지한다.
 *
 * 메인 띠 배너가 생겼을 경우에는
 * 메인 띠 배너 초기화될 때 window.__mainEventActive() 함수를 호출하고
 * window.__mainEventActive 함수가 호출되면 scroll event가 등록되며 특정 위치에서 fixed 되도록 처리가 된다.
 * 메인 띠 배너를 닫을 때 window.__headerFixedCheckerRemove() 함수를 호출하여
 * scroll event를 삭제하고 고정된 상태를 유지시킨다.
 */
const mainHeaderFixed = () => {
  let fixedY = 0;
  // ly-header
  const wrap = document.querySelector('.ly-wrap');
  if (!wrap) return;
  const headerEl = document.querySelector('.ly-wrap.main .ly-header');
  wrap.classList.add('fixed');

  window.__mainEventActive = function () {
    fixedY = 60;
    if (headerEl) {
      EventHandler.on(
        window,
        'scroll.header',
        optimizeCaller(() => {
          if (window.pageYOffset > fixedY) {
            wrap.classList.add('fixed');
          } else {
            wrap.classList.remove('fixed');
          }
        }),
      );
      EventHandler.trigger(window, 'scroll.header');
    }
    window.__mainEventActive = null;
  };

  window.__headerFixedCheckerRemove = function () {
    EventHandler.off(window, 'scroll.header');
    if (wrap) {
      wrap.classList.add('fixed');
    }
    window.__headerFixedCheckerRemove = null;
  };
};

/**
 * 요금제 비교함 뱃지 아이콘
 */
const badgeOpenner = () => {
  const badge = document.querySelector('.c-modal__content .c-side-badge');
  if (badge) {
    const modalBody = document.querySelector('.c-modal__body');
    let timer;
    modalBody.addEventListener('scroll', () => {
      let lastScrollTop = 0;
      const st = window.pageYOffset;
      if (st < lastScrollTop) {
        badge.classList.remove('is-active');
      } else {
        badge.classList.add('is-active');
      }
      lastScrollTop = st <= 0 ? 0 : st;
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        badge.classList.remove('is-active');
      }, 700);
    });
  }
};

/**
 * 카드 선택 시 스크롤 고정
 */
const modalInRadioScrollBlock = () => {
  EventHandler.on(document, 'click.radio-block', e => {
    // 모달팝업 속에있는 카드만
    if (!e.target.classList.contains('c-card__label')) return;
    const inModalBody = e.target.closest('.c-modal__body .c-card');
    if (inModalBody) {
      const chkRadio = inModalBody.querySelector('.c-radio');
      if (chkRadio) {
        const cModalPosition = document.querySelector('.c-modal__body').getBoundingClientRect();
        const chkRadioHeight = chkRadio.getBoundingClientRect().height; // * 2;
        const spacing = 2;
        const cardYPosition = inModalBody.getBoundingClientRect().top;
        if (cModalPosition.top >= cardYPosition) {
          const diffY = cModalPosition.top - cardYPosition + spacing;
          chkRadio.style.top = `${diffY}px`;
        } else if (Math.floor(cardYPosition + chkRadioHeight) >= Math.floor(cModalPosition.bottom)) {
          chkRadio.style.top = `${0}px`;
        } else {
          chkRadio.style.top = '';
        }
      }
    }
  });
};

/**
 * p5 플러그인이 document에 wheel 이벤트를 등록한다.
 * 무슨이유인지는 모르겠지만 이 이벤트때문에 input number 에서 wheel 작동 시
 * 화면 스크롤이 block되고 인풋의 숫자가 카운팅된다.
 * p5 에서 등록한 이벤트를 삭제할 수 없어서 (혹시 내가 모르고 있을지도..)
 * number 인풋을 찾아 wheel 이벤트 발생 시 포커스 아웃 되도록 처리한다.
 * 이 증상은 p5 플러그인 사용한 페이지(게임)에서 생겨나지만
 * 게임 팝업이 어떤 페이지에서부터 생성되어있는지 알 수 없기에 전역으로 처리한다.
 */
const blockWheel = () => {
  const elements = document.querySelectorAll('input[type="number"]');
  elements.forEach(el => {
    if (initializeCheck(el)) {
      setInitialize(el);
      EventHandler.on(el, 'wheel', event => {
        document.activeElement.blur();
      });
    }
  });
};

// 이곳에서....
const initFunc = () => {
  datepickerValueBinder();

  // bottom sheet
  bsCompareBottomSheet();
  // 공통 헤더 플로팅 처리
  headerFixed();
  // gnb
  gnb();
  // fab (접근성 추가)
  a11yFab();
  // active menu
  selectedCurrentMenu('.ly-header__nav');
  selectedCurrentMenu('.ly-allmenu__wrap');
  // 메인 쪽 헤더 고정
  mainHeaderFixed();
  // 모달내 요금제 비교함 뱃지 처리
  badgeOpenner();
  // 모달 스크롤 컨테이너 속 라디오 선택 시 스크롤 막기
  modalInRadioScrollBlock();
};

/**
 * initialize 함수를 통해서 재초기화 필요가 있는 함수들
 * 이 함수에 추가되는 함수들은 이벤트리스너 중복으로 등록되는 사항에 주의
 */
const initialize = () => {
  clickToScroll();
  // 사은품 스크롤 영역
  presentsRow();
  // 인풋 포커스 활성화 시 레이블 애니메이션 처리
  formInteraction();
  // 셀렉트 폼에서 값 선택 후 레이블 및 값 유지 처리
  selectInteraction();
  // 인풋 그룹 포커스 활설화 시 아웃라인 처리
  inputGroupInteraction();
  // filter 스크롤 영역 변경
  scrollChange();
  // 검색 인풋 활성화 시 버튼 노출
  searchBoxAction();
  // 탭 변경 시 스크롤 초기화
  tabChangeToScroll();
  // wheel block -> number input
  blockWheel();
  // counter
  counter();
};

const commonFunc = {
  initFunc,
  initialize,
  datepickerValueBinder,
};

export default commonFunc;
